import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=a4ee67ac&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"
import style0 from "./notice.vue?vue&type=style&index=0&id=a4ee67ac&prod&lang=scss&scoped=true"
import style1 from "./notice.vue?vue&type=style&index=1&id=a4ee67ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ee67ac",
  null
  
)

export default component.exports